
// components/CommonStepperSection.js
import React from 'react';
import { FaCheck, FaTimes, FaRegFilePdf } from 'react-icons/fa';
import * as bie from 'react-bootstrap';
import CommonFormHeading from '../../CommonUtils/CommonFormHeading';

const CommonStepperSection = ({
    heading,
    statusObj,
    stepTitles,
    fieldToStepIndex,
    currentStep,
    setCurrentStep,
    allDone,
    GetPdf,
}) => {
    return (
        <>
            {heading && <CommonFormHeading heading={heading} />}
            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                <div className="inner-herbpage-service-title-sub pt-0 mb-3 d-flex align-items-center">
                    <h1 className="mb-0">
                        College Name: <span>{statusObj?.inst_name}</span>
                    </h1>
                    <h1 className="mb-0 ms-4">
                        College Code: <span>{statusObj?.coll_code}</span>
                    </h1>
                </div>

                <bie.Container fluid className="pt-5 d-flex justify-content-center">
                    <bie.Row>
                        <bie.Col md={12} className="px-4">
                            <div className="vertical-stepper">
                                {stepTitles.map((title, i) => {
                                    const stepIndex = i + 1;
                                    const fieldName = Object.keys(fieldToStepIndex).find(
                                        (key) => fieldToStepIndex[key] === i
                                    );
                                    const val = statusObj[fieldName];
                                    const isDone = val === 'Done';
                                    const isActive = stepIndex === currentStep;

                                    return (
                                        <div key={i} className="stepper-step d-flex mb-4">
                                            <div className="icon-column d-flex flex-column align-items-center">
                                                <div
                                                    className={`step-circle ${isDone ? 'completed' : isActive ? 'active' : 'pending'
                                                        }`}
                                                >
                                                    {isDone ? <FaCheck /> : stepIndex}
                                                </div>
                                                {i < stepTitles.length - 1 && (
                                                    <div
                                                        className={`step-line ${stepIndex < currentStep ? 'line-completed' : ''
                                                            }`}
                                                    ></div>
                                                )}
                                            </div>
                                            <button
                                                type="button"
                                                className="step-text ps-3"
                                                onClick={() => setCurrentStep(stepIndex)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <div
                                                    className={`step-label ${isDone ? 'label-done' : ''
                                                        } ${isActive ? 'active-label' : ''}`}
                                                >
                                                    {title}
                                                </div>
                                                <div className="step-status mt-1">
                                                    <bie.Badge bg={isDone ? 'success' : 'danger'}>
                                                        {isDone ? (
                                                            <>
                                                                <FaCheck className="me-1" /> Done
                                                            </>
                                                        ) : (
                                                            <>
                                                                <FaTimes className="me-1" /> Not Done
                                                            </>
                                                        )}
                                                    </bie.Badge>
                                                </div>
                                            </button>
                                        </div>
                                    );
                                })}
                            </div>
                        </bie.Col>

                        <center>
                            {allDone && (
                                <button
                                    type="button"
                                    className="btn btn-sm affl-print me-2"
                                    onClick={GetPdf}
                                >
                                    click here to download &emsp;
                                    <FaRegFilePdf size={20} />
                                </button>
                            )}
                        </center>
                    </bie.Row>
                </bie.Container>
            </bie.Container>
        </>
    );
};

export default CommonStepperSection;
